import React, { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AppBreadcrumbs from '../components/AppBreadcrumbs';
import { Box, Container } from '@mui/material';
import { MetaTitle } from '../components/MetaTitle';
import AppPaper from '../../components/content/AppPaper';
import PricingPlanWarning from '../components/PricingPlanWarning';
import AdditionalHeader, { ButtonType } from '../components/AdditionalHeader';
import { useComponentHeightMeasuring } from '../../utils/hooks/useComponentHeightMeasuring';

const isBreadCrumbsNeeded = (pathname: string) => {
	return '/' !== pathname;
};

type MainLayoutProps = {
	children: ReactNode;
	paper?: boolean;
	buttons?: ButtonType[];
};

const MainLayout: FC<MainLayoutProps> = ({ children, paper = true, buttons }) => {
	const { pathname } = useLocation();
	const { footerHeight } = useComponentHeightMeasuring();

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					minHeight: `calc(100vh - ${footerHeight}px)`, // - footer height
				}}
			>
				<MetaTitle />
				<Header />
				{buttons && <AdditionalHeader buttons={buttons} />}
				{isBreadCrumbsNeeded(pathname) && <AppBreadcrumbs />}
				<Container
					id="app-container"
					sx={{
						paddingY: 5,
					}}
				>
					<PricingPlanWarning />
					{paper ? <AppPaper>{children}</AppPaper> : <>{children}</>}
				</Container>
			</Box>
			<Footer />
		</>
	);
};

export default MainLayout;
